import React, { useEffect, useState } from "react";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useCookie } from "../../../../contexts/cookieContext/cookieContext.js";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import { useParams } from "react-router-dom";
import queryString from "query-string";
import ReactDOM from "react-dom";
import { Link, useLocation } from "react-router-dom";
import PopUpContainerNotifications from "./PopUpContainerNotifications.js";

const PopUpNotifications = () => {
  const params = useParams();
  const { getUserData, isLoggedIn } = useUser();
  const { getLanguage, getCurrentPage, getDirection } = useContent();
  const { getCookie, setCookies, removeCookies } = useCookie();
  const location = useLocation();
  const searchParams = queryString.parse(location.search);
  const uidParam = searchParams.uid;
  //const [notificationData, setNotificationData] = useState(null);
  useEffect(() => {
    let displayNotification = false;
    //check if the current page is gallery or collection or home, if home, set the location to home else set it to download

    let displayLocation = "download";

    if (
      getCurrentPage() === "gallery" ||
      getCurrentPage() === "collection" ||
      getCurrentPage() === "home"
    ) {
      displayNotification = true;
      if (getCurrentPage() === "home") {
        displayLocation = "new-home-page";
      }
    }
    if (displayNotification) {
      const existUidParam = uidParam !== undefined;
      let isAdminNotification = false;

      if (params.anotherParam !== undefined) {
        if (params.anotherParam.includes("preview-notification")) {
          isAdminNotification = true;
        }
      }

      if (isAdminNotification) {
        const notificationId = params.anotherParam.split(
          "preview-notification-"
        )[1];
        if (notificationId) {
          getPopUpNotificationAdmin(notificationId);
        }
      } else {
        if (!checkIfExistNotificationCookie()) {
          if (isLoggedIn()) {
            getPopUpNotificationUsers(null, displayLocation);
          } else {
            if (existUidParam) {
              getPopUpNotificationUsers(uidParam, displayLocation);
            } else {
              getPopUpNotificationAnonymous(displayLocation);
            }
          }
        }
      }
    }
  }, [getCurrentPage(), isLoggedIn()]);

  const checkIfExistNotificationCookie = () => {
    //Test-DisplayNotification
    let response = false;
    const cookieNotificationForToday = getCookie("DisplayNotification");
    const cookieNotificationForTodayTest = getCookie(
      "Test-DisplayNotification"
    );
    if (window.location.href.includes("test.jumbomail")) {
      //check if cookieNotificationForTodayTest or cookieNotificationForToday is true, if true, return true, else return false
      if (cookieNotificationForTodayTest === "true") {
        return true;
      } else if (cookieNotificationForToday === "true") {
        return true;
      } else {
        return false;
      }
    } else {
      //check if cookieNotificationForToday is true, if true, return true, else return false
      if (cookieNotificationForToday === "true") {
        return true;
      } else {
        return false;
      }
    }

    return response;
  };

  const getPopUpNotificationUsers = async (uid = null, location = null) => {
    const parameters = {
      userId: uid ? 0 : getUserData().UserId,
      cookie: getCookie("HomeNotification"),
      culture: getLanguage(),
      locationPopUp: location ? location : "download",
      uid: uid ? uid : !getUserData().UserId ? "empty" : "",
    };

    const response = await apiRequest(
      "Notifications",
      "GetHomePopUpNotificationUsers",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setCookieDisplayToday();
        renderModal(response.data, false);
      } else {
      }
    }
  };

  const getPopUpNotificationAdmin = async (id) => {
    const parameters = {
      notificationId: id,
      culture: getLanguage(),
    };

    const response = await apiRequest(
      "Notifications",
      "GetTemplateNotificationByTemplateId",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        let tempNotification = { ...response.data };
        tempNotification.NotificationImage = response.data.Image;
        tempNotification.NotificationTitle = response.data.Title;
        tempNotification.NotificationText = response.data.Text;
        tempNotification.NotificationLinkUrl = response.data.LinkUrl;
        tempNotification.NotificationLinkTarget = response.data.LinkTarget;

        renderModal(tempNotification, true);
      } else {
      }
    }
  };

  const getPopUpNotificationAnonymous = async (location = null) => {
    const parameters = {
      cookie: getCookie("HomeNotification"),
      culture: getLanguage(),
      locationPopUp: location ? location : "download",
    };

    const response = await apiRequest(
      "Notifications",
      "GetHomePopUpNotificationAnonymous",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setCookieDisplayToday();
        renderModal(response.data, false);
      } else {
      }
    }
  };

  const setCookieDisplayToday = () => {
    //set cookie for today, exipre in 24 hours
    if (window.location.href.includes("test.jumbomail")) {
      removeCookies("Test-DisplayNotification");
      setCookies("Test-DisplayNotification", true, {
        path: "/",
        domain: ".jumbomail.me",
        expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      });
    } else {
      removeCookies("DisplayNotification");
      setCookies("DisplayNotification", true, {
        path: "/",
        domain: ".jumbomail.me",
        expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      });
    }
  };

  const [notiData, setNotiData] = useState(null);
  const [previewAdmin, setPreviewAdmin] = useState(false);

  const renderModal = (notificationData, previewAdmin) => {
    if (notificationData) {
      setNotiData(notificationData);
      setPreviewAdmin(previewAdmin);

      const notiSidebarContainer = document.querySelector(
        ".notification-sidebar-modal-portal"
      );

      if (!notiSidebarContainer) {
        const notiSidebarContainer = document.createElement("div");
        notiSidebarContainer.className = `notification-sidebar-modal-portal ${getDirection()}`;
        document.body.appendChild(notiSidebarContainer);
      }

      // setModal({
      //   modal: PopUpContainerNotifications,
      //   modalOverlayClass: `marketing-modal-overlay${
      //     getCurrentPage() === "home" ? " modal-side-notification" : ""
      //   }`,
      //   props: {
      //     data: notificationData,
      //     previewAdmin: previewAdmin,
      //   },
      // });
    }
  };

  return notiData
    ? ReactDOM.createPortal(
        <PopUpContainerNotifications
          data={notiData}
          previewAdmin={previewAdmin}
        />,
        document.querySelector(".notification-sidebar-modal-portal")
      )
    : null;
};

export default PopUpNotifications;
